export const EMBEDDED_PAYMENT_METHODS = {
  APPLE_PAY: 'APPLE_PAY',
  GOOGLE_PAY: 'GOOGLE_PAY',
  IN_APP_STORED_PAYMENT: 'IN_APP_STORED_PAYMENT',
};

export const EMBEDDED_EVENTS = {
  WEBVIEW_CLOSE: 'WEBVIEW_CLOSE',
};
